import {
    allCountryNames,
    allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode
} from "../components/settings/utils";
import {
    convertCountriesFromDropdownFormat,
    convertCountriesToDropdownFormat,
    convertInternationalPhonePrefixesToDropdownFormat
} from "../utils/converter/dropdown";
import {ACTIVITY_TYPE, TRAVEL_OPTION_TYPE} from "../types-enums/activity";

export const INTERNATIONAL_PHONE_PREFIX_CODES_FOR_DROPDOWN = convertInternationalPhonePrefixesToDropdownFormat(allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode)

export interface ActivityOptionsProps {
    title: string,
    activityType: ACTIVITY_TYPE,
    travelOptionType: TRAVEL_OPTION_TYPE
}

export const ACTIVITY_OPTIONS: ActivityOptionsProps[] = [
    {
        title: "ACTIVITIES.FLIGHT.TITLE",
        activityType: ACTIVITY_TYPE.flight,
        travelOptionType: TRAVEL_OPTION_TYPE.transport
    },
    {
        title: "ACTIVITIES.HOTEL.TITLE",
        activityType: ACTIVITY_TYPE.hotel,
        travelOptionType: TRAVEL_OPTION_TYPE.accommodation
    },
    {
        title: "ACTIVITIES.CAR_BUS.TITLE",
        activityType: ACTIVITY_TYPE.car_bus,
        travelOptionType: TRAVEL_OPTION_TYPE.transport
    },
    // {
    //     title: "ACTIVITIES.TRAIN.TITLE",
    //     activityType: ACTIVITY_TYPE.train,
    //     travelOptionType: TRAVEL_OPTION_TYPE.transport
    // },
]
export const FLIGHT_PROPERTIES = {
    minNumberFlights: 1,
    maxNumberFlights: 1000,
    minNumberPassenger: 1,
    maxNumberPassenger: 1000,
    calculationMethod: "default",
}
export const INTERNATIONAL_PHONE_PREFIX_GERMANY = "+49"
export const INTERNATIONAL_PHONE_PREFIX_AUSTRIA = "+43"
export const INTERNATIONAL_PHONE_PREFIX_SWITZERLAND = "+41"
export const TOP_INTERNATIONAL_PHONE_PREFIXES = [INTERNATIONAL_PHONE_PREFIX_GERMANY, INTERNATIONAL_PHONE_PREFIX_AUSTRIA, INTERNATIONAL_PHONE_PREFIX_SWITZERLAND]
export const COUNTRY_NAME_GERMANY = "Germany"
export const COUNTRY_NAME_AUSTRIA = "Austria"
export const COUNTRY_NAME_SWITZERLAND = "Switzerland"
export const TOP_COUNTRY_NAMES = [COUNTRY_NAME_GERMANY, COUNTRY_NAME_AUSTRIA, COUNTRY_NAME_SWITZERLAND]
export const COOKIE_NAME = "app.at"
export const COOKIE_EXPIRY_NAME = "app.at_exp"
export const USER_COOKIE = "user"
export const HOTEL_PROPERTIES = {
    minNumberRooms: 1,
    maxNumberRooms: 200,
    minNumberGuests: 1,
    maxNumberGuests: 700,
    minNumberNights: 1,
    maxNumberNights: 360,
    calculationMethod: "default",
}
export const JOURNEY_PROPERTIES = {
    minNumberPeople: 1,
    maxNumberPeople: 100,
    minNumberNights: 1,
    maxNumberNights: 100,
}
export const VALIDATE_FORM_STARTING_NUMBER = 0
export const RESET_FORM_STARTING_NUMBER = 0
export const TOP_INTERNATIONAL_PHONE_PREFIX_CODES_ID: number[] = INTERNATIONAL_PHONE_PREFIX_CODES_FOR_DROPDOWN
    .filter(internationalPhonePrefix => TOP_INTERNATIONAL_PHONE_PREFIXES.includes(internationalPhonePrefix.label.slice(-3)))
    .map(result => result.value)

export const COUNTRY_NAMES_FOR_DROPDOWN = convertCountriesToDropdownFormat(allCountryNames)

export const defaultCountriesForTop = () => COUNTRY_NAMES_FOR_DROPDOWN
    .filter(country => TOP_COUNTRY_NAMES.includes(country.label))
    .map(result => result.value)

export const INITIAL_SELECTED_INTERNATIONAL_PHONE_PREFIX = "DE" as string

export const INITIAL_SELECTED_COUNTRY = convertCountriesFromDropdownFormat(
    convertCountriesToDropdownFormat(allCountryNames)
        .filter(country => country.label === COUNTRY_NAME_GERMANY)
)
export const TERMS_AND_CONDITIONS_PDF_NAME = "KlimaLink_Terms_and_Conditions.pdf"
export const MANUAL_PDF_NAME = "KlimaLink_Manual.pdf"

export const STAGE_LINK_PDF = 'https://b2b.dev.klimalink.org/documents'
export const PROD_LINK_PDF = 'https://b2b.klimalink.org/documents'

export enum Luf {
    flight = "flight",
    // car = "car_bus",
    hotel = "hotel"
}